import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { getTdsReports } from '@zet/earnings'

import {
  fetchMyTeamsEarnings,
  fetchMyTeamsEarningsFilters,
  fetchMyTeamsTotalEarnings,
  showPayoutEarnings,
} from './functions'
import { IMyTeamsEarningsFilter } from './types'

function useMyTeamsEarningsTotal() {
  return useQuery(['fetchMyTeamsTotalEarnings'], fetchMyTeamsTotalEarnings)
}

function useMyTeamsEarnings(filters: IMyTeamsEarningsFilter | any) {
  return useInfiniteQuery(
    ['fetchMyTeamsEarnings', filters],
    ({ pageParam = 0 }) => {
      return fetchMyTeamsEarnings({
        filters,
        pagination: { limit: 10, offset: pageParam || 0 },
      })
    },
    {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length * 10 <= lastPage.total) {
          return lastPage.nextOffset
        }
        return undefined
      },
    }
  )
}

function useMyTeamsEarningsFilters() {
  return useQuery(['fetchMyTeamsEarningsFilters'], fetchMyTeamsEarningsFilters)
}

function useTdsReports(year: string) {
  return useQuery(['userTdsReport', year], () => getTdsReports(year))
}

function useShowPayoutEarnings() {
  return useQuery(['showPayoutEarnings'], showPayoutEarnings)
}

export {
  useMyTeamsEarnings,
  useMyTeamsEarningsFilters,
  useMyTeamsEarningsTotal,
  useShowPayoutEarnings,
  useTdsReports,
}
